module.exports = __webpack_public_path__ + "static/media/icon_arrow_nav.f9066bd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_arrow_nav.svg
// module id = 321
// module chunks = 0